import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/sbw 1.png";
import background from "../assets/background.png";
import Button from "./Button";
import FeatherIcon from "feather-icons-react";

const ConfirmSignup = () => {
  const history = useNavigate();
  return (
    <>
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-4 md:col-span-6 lg:col-span-7 xl:col-span-7 2xl:col-span-8"></div>
          <div className="min-h-screen p-8 top-[60px] col-span-8 md:col-span-6 lg:col-span-5 xl:col-span-5 2xl:col-span-4 bg-[#0d223d]/60 backdrop-blur-[80px] shadow-lg inline-flex">
            <div className="w-full flex-col justify-center items-center inline-flex gap-6">
              <>
                <img src={Logo} className="mb-6" />
              </>
              <div className="w-full border-t border-[#b3b5bd] mb-6"></div>
              <div className="font-normal text-[#F3F4F8] font-Poppins text-center md:mb-3 lg:mb-4 xl:mb-5 2xl:mb-6 flex flex-col items-center">
                <div className="bg-green-500 rounded-full flex items-center justify-center  md:h-10 md:w-10 lg:h-12 lg:w-12 xl:h-14 xl:w-14 2xl:h-16 2xl:w-16">
                  <FeatherIcon
                    icon="check-circle"
                    className="text-white size-5 md:size-5 lg:size-6 xl:size-7 2xl:size-8"
                  />
                </div>
                <span className="space-y-1 2xl:space-y-2">
                  <h6 className="text-xs md:text-xs lg:text-sm xl:text-base 2xl:text-lg">
                    Your email has been verified successfully!
                  </h6>
                  <h6 className="text-xs md:text-xs lg:text-xs xl:text-xs 2xl:text-sm">
                    Please check your email for the next update.
                  </h6>
                </span>
              </div>
              <Button
                type="submit"
                onClick={() => history("/login")}
                primary={true}
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmSignup;
